export default __webpack_public_path__ + "static/media/part-2.efefd762.jpg";